// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const StackedBarChartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="StackedBarChartIcon" ref={forwardedRef} {...props}>
      <path d="M3 3h1.5v12.5H17V17H4a1 1 0 0 1-1-1z" />
      <path d="M14.25 11H16v3h-1.75z" />
      <path d="M16 7h-1.75v3H16z" />
      <path d="M10.375 6.5h1.75V14h-1.75z" />
      <path d="M12.125 3h-1.75v2.5h1.75z" />
      <path d="M6.5 10h1.75v4H6.5z" />
      <path d="M8.25 5H6.5v4h1.75z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const StackedBarChartIcon = /* @__PURE__ */ Object.assign(
  StackedBarChartIconComponent,
  { displayName: 'StackedBarChartIcon' },
);
